module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_8-a5a11f2e93f009acca05786bb6099075.svg";